export function createProyectoEstatus() {
  return {
    Clave: '',
    EmpresaId: 0,
    Nombre: '',
    Descripcion: '',
    Orden: 0,
    Color: '#64748b',
    EsInicial: false,
    EsFinal: false,
    PermiteAvance: true,
    EsActivo: true
  };
}

export const coloresProyectoEstatus = [
  '#64748b',
  '#2563eb',
  '#16a34a',
  '#ca8a04',
  '#dc2626',
  '#7c3aed',
  '#0891b2',
  '#475569'
];
